/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 23:35:47
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-11 21:44:11
 */

const appInfo = {
  // appid: 'wxe1acd2a4170297cd',
  // appid: 'wxf51de93710e8c664',
  scope: 'snsapi_base',
  state: 'spdr1234',
  responseType: 'code'
}

export const map_key = '0c6ea0e2c174d400746b41aee1db0db4' // 高德AK
export const cryptoKey = 'o58.topAAABBBZZZ' // 16位密钥
export const ivSet = 'qcwp'
export const channelCode = 'JINGXIU_PAY'